import CryptoJS from 'crypto-js';


const key = 'ningcaichencto66'
const iv = '66otcnehciacgnin'
/**
 * 解密 这里使用的是CBC模式 必须要设置偏移量
 * @param {*} content 需要解密字符串
 * @param {*} key key
 * @param {*} iv 偏移量
 * @returns 
 */
export function decryptAES(content) {
    var encodeKey = CryptoJS.enc.Utf8.parse(key);
    var encodeIv = CryptoJS.enc.Utf8.parse(iv);
    var decrypt = CryptoJS.AES.decrypt(content, encodeKey, {
        iv: encodeIv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    var decryptedStr = CryptoJS.enc.Utf8.stringify(decrypt);
    return decryptedStr.toString();
}

/**
 * 加密 这里使用的是CBC模式 必须要设置偏移量
 * @param {*} str 需要加密字符串
 * @param {*} key key
 * @param {*} iv 偏移量
 * @returns 
 */
export function encryptAES(str) {
    var srcs = CryptoJS.enc.Utf8.parse(str);
    var encodeKey = CryptoJS.enc.Utf8.parse(key);
    var encodeIv = CryptoJS.enc.Utf8.parse(iv);
    var encrypted = CryptoJS.AES.encrypt(srcs, encodeKey, {
        iv: encodeIv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
};

/** 
 * MD5摘要
 * @param {*} 需要转换的字符串
 * @returns 
 */
export function md5(str) {
    return CryptoJS.MD5(str).toString().toUpperCase();
}

// export default {
//   decryptWithKeyAndIv: decryptWithKeyAndIv,
//   encryptDataWithKeyAndIv: encryptDataWithKeyAndIv,
//   aesDecrypt: aesDecrypt,
//   aesEncrypt: aesEncrypt
// };